var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.apply_filters)?_c('div',{staticClass:"generic-explorer-cont"},[(_vm.apply_filters)?_c('GenericExplorer',{attrs:{"filters":_vm.apply_filters,"views":[{name: 'ExplorerTable',..._vm.props['ExplorerTable']}],"headless":""}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }